import React from 'react';
import cn from 'classnames';
import stylesLoadingIndicator from './loading-indicator.module.scss';
import stylesSpinner from './spinner.module.scss';
var LoadingIndicator = function (_a) {
    var size = _a.size, centred = _a.centred;
    return (React.createElement("div", { "data-testid": "loading-indicator", className: cn(stylesLoadingIndicator.spinner, size && stylesLoadingIndicator[size], centred && stylesLoadingIndicator.centred) }));
};
export default function Spinner(_a) {
    var active = _a.active;
    return active ? (React.createElement("div", { "data-testid": "spinner", className: stylesSpinner.spinnerWrap },
        React.createElement(LoadingIndicator, null))) : null;
}
